// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2fSEN","choiceBoxes":"toolbarselects_choiceBoxes__2dbqh","simpleField":"toolbarselects_simpleField__1ewm1"};